<template>
  <v-card
    variant="flat"
    :style="{
      background: colorMap[type].background,
      borderLeft: confirmedAt ? '3px solid green' : undefined,
    }">
    <v-card-text class="d-flex justify-space-between align-center ga-3">
      <div class="d-flex ga-3">
        <div>
          <v-avatar :color="colorMap[type].avatarBg" size="32">
            <span
              class="font-weight-bold font-size-13"
              :class="`text-${colorMap[type].avatarText}`">
              {{ user.name?.[0] + user.surname?.[0] }}
            </span>
          </v-avatar>
        </div>

        <div>
          <div class="d-flex align-center ga-3">
            <div class="font-weight-bold font-size-14">
              {{ getPersonName(user) }}
            </div>

            <v-chip
              density="compact"
              rounded="pill"
              :color="acceptanceType.id === 1 ? 'info' : 'warning'">
              <b class="font-size-10">{{ acceptanceType.name }}</b>
            </v-chip>
          </div>
          <div class="text-disabled font-size-13">{{ user.post }}</div>
          <div v-if="confirmedAt" class="text-green-darken-2 font-size-13">
            {{
              new CustomDate(confirmedAt).toString({
                time: true,
              })
            }}
          </div>
        </div>
      </div>

      <v-btn
        v-if="!confirmedAt && acceptanceId && canDelete"
        v-tooltip="'Видалити'"
        variant="outlined"
        density="compact"
        color="grey"
        :loading="$loading.isLoading(`acceptanceDelete_${acceptanceId}`)"
        icon
        @click="acceptanceDelete(acceptanceId)">
        <v-icon icon="mdi-close" color="error" size="small"></v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { CustomDate, getPersonName } from 'best-modules/utils'
import { useDocument } from '../../document'
import { UserLink } from '@/utils/types/user'
import { ISODate } from 'best-modules/utils/customDate'
import { DefaultItem } from 'best-modules/plugins/directory/types'
import { computed } from 'vue'
import { useStore } from '@/plugins'

defineOptions({
  name: 'AcceptanceUser',
})

defineProps<{
  acceptanceId?: number
  acceptanceType: DefaultItem
  user: UserLink
  confirmedAt?: ISODate
  type: 'departmentChild' | 'completed' | 'default'
}>()

const { acceptanceDelete, documentSource } = useDocument()
const store = useStore()
const userId = computed(() => store.state.user.userData?.id)

const canDelete = computed(() => {
  const allowedStatuses = ['draft', 'registered']
  return (
    allowedStatuses.includes(documentSource.status) &&
    documentSource.createdBy === userId.value
  )
})

const colorMap = {
  completed: {
    background: '#f0f9f3',
    avatarBg: 'green-lighten-4',
    avatarText: 'green-darken-2',
  },
  // default: {
  //   background: '#e6f1fb',
  //   avatarBg: 'white',
  //   avatarText: 'light-blue-darken-4',
  // },
  default: {
    background: 'white',
    avatarBg: '#e6f1fb',
    avatarText: 'light-blue-darken-4',
  },
  departmentChild: {
    background: 'white',
    avatarBg: '#e6f1fb',
    avatarText: 'light-blue-darken-4',
  },
}
</script>
